// extracted by mini-css-extract-plugin
module.exports = {"nodeStatsButton":"NodeStatsButton_nodeStatsButton__JZBqe"};